<template>
    <div class="deposito operacao row">
        <!-- <h4>
            {{operacao.Descricao}}
        </h4> -->
        <div class="col-12 col-md-7 sep">

            <table class="info">
                <thead>
                    <th colspan="2">
                        Detalhes da Transferencia
                    </th>
                </thead>
                <tbody>
                    <tr>
                        <td>Valor</td>
                        <td class="text-right">R$ {{ formatarDinheiro(valor) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="detalhes col-12 col-md-5">
             <div class="options">
                <p>
                    ID da Transação
                    <strong>
                        {{ transacao }}
                    </strong>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Masker from '@/utils/masker'

    export default {
        props: {
            operacao: {type: Object}
        },


        created() {
            console.log(JSON.stringify(this.operacao));
        },

        computed: {
            valor() {
                return this.operacao.Valor
            },
            transacao() {
                return this.operacao.id
            },
        },

        methods: {
            formatDocument(doc) {

                if(doc.length > 11) {
                    return Masker.maskCnpj(doc);
                } else {
                    return Masker.maskCpf(doc);
                }
            },
            formatarDinheiro(value) {

                if(value != null){

                    if(typeof value  == "string") value = parseFloat(value)

                    let options = { 
                        minimumFractionDigits: 2, 
                        maximumFractionDigits: 2
                    }

                    return value.toLocaleString('pt-BR', options )
                }

                return 0
            },
        }
    }
</script>

<style lang="scss" scoped>


// WEBPACK FOOTER //
// src/components/Wallet/Operacoes/Transferencia.vue